import { EMA_LABEL_SECTIONS } from '../../types/dtos/ema';
import type { EmaLabelSectionMap, EmaLabelSectionValues } from '../../types/dtos/ema';
import type { EmaLabelSectionErrors } from './EMALabelSeparation.types';

export const normalizeEmaLabelSections = (
  labels?: Partial<EmaLabelSectionMap>
): EmaLabelSectionValues =>
  EMA_LABEL_SECTIONS.reduce<EmaLabelSectionValues>((result, section) => {
    const value = labels?.[section];
    return {
      ...result,
      [section]: value === null || value === undefined || value === '' ? null : String(value)
    };
  }, {} as EmaLabelSectionValues);

export const getEmaLabelSeparationError = (body: unknown, fallback: string): string =>
  typeof body === 'string' && body.trim() ? body : fallback;

export const validateEmaLabelSections = (labels: EmaLabelSectionValues): EmaLabelSectionErrors => {
  const errors: EmaLabelSectionErrors = {};
  const sectionsByPage = new Map<string, (typeof EMA_LABEL_SECTIONS)[number][]>();

  EMA_LABEL_SECTIONS.forEach(section => {
    const value = labels[section];
    if (!value) {
      return;
    }
    if (!/^[1-9]\d*$/.test(value)) {
      errors[section] = 'Enter a valid page number';
      return;
    }

    const sections = sectionsByPage.get(value) ?? [];
    sections.push(section);
    sectionsByPage.set(value, sections);
  });

  sectionsByPage.forEach(sections => {
    if (sections.length > 1) {
      sections.forEach(section => {
        errors[section] = 'Page number already linked';
      });
    }
  });

  return errors;
};
